import { createClient } from '@supabase/supabase-js'

// Environment variables - Cloudflare Pages için
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.VITE_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY || process.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY

// Debug: Environment variables kontrolü (production'da da çalışır)
console.log('🔍 Environment Variables Check:')
console.log('REACT_APP_SUPABASE_URL:', process.env.REACT_APP_SUPABASE_URL ? `✓ Set (${process.env.REACT_APP_SUPABASE_URL.substring(0, 30)}...)` : '✗ Missing')
console.log('REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY:', process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY ? `✓ Set (${process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY.substring(0, 20)}...)` : '✗ Missing')
console.log('VITE_SUPABASE_URL:', process.env.VITE_SUPABASE_URL ? `✓ Set (${process.env.VITE_SUPABASE_URL.substring(0, 30)}...)` : '✗ Missing')
console.log('VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY:', process.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY ? `✓ Set (${process.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY.substring(0, 20)}...)` : '✗ Missing')
console.log('All SUPABASE env vars:', Object.keys(process.env).filter(key => key.includes('SUPABASE')))

if (!supabaseUrl) {
  console.error('❌ REACT_APP_SUPABASE_URL is missing!')
  console.error('Available env vars:', Object.keys(process.env).filter(key => key.includes('SUPABASE')))
  console.error('All env vars starting with REACT_APP_:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')))
  throw new Error('REACT_APP_SUPABASE_URL environment variable is required! Please set it in Cloudflare Pages Environment Variables.')
}

if (!supabaseAnonKey) {
  console.error('❌ REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY is missing!')
  console.error('Available env vars:', Object.keys(process.env).filter(key => key.includes('SUPABASE')))
  console.error('All env vars starting with REACT_APP_:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')))
  throw new Error('REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY environment variable is required! Please set it in Cloudflare Pages Environment Variables.')
}

console.log('✅ Supabase client oluşturuluyor...')
console.log('URL:', supabaseUrl)
console.log('Key length:', supabaseAnonKey?.length || 0)

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

